import { SET_TEMPLATELIST } from '../actions';

const templatelist = (state = [], action) => {
  switch (action.type) {
	case SET_TEMPLATELIST:
      return [...action.value];  
    default: return state;
  }
}

export default templatelist;
